export default __webpack_public_path__ + "static/media/par2.baf1905a.jpg";